import VariableCard from './VariableCard';
import { VariableCardProps, VariableCardValueProps } from './types';

export type { VariableCardProps, VariableCardValueProps };
export default VariableCard;
